import Header from './landing/Header';
import Hero from './landing/Hero';
import Features from './landing/Features';
import ProgressShowcase from './landing/ProgressShowcase';
import HowItWorks from './landing/HowItWorks';
import CtaBanner from './landing/CtaBanner';

export default function Landing() {
  return (
    <div className="min-h-screen bg-white flex flex-col text-gray-800 font-hind">
      <Header />
      <main className="flex-1">
        <Hero />
        <Features />
        <ProgressShowcase />
        <HowItWorks />
        <CtaBanner />
      </main>
    </div>
  );
}
